module.exports = __webpack_public_path__ + "static/pic15-c00373275a1321f6a0b91100d3190e21.gif";